type ValidateApiResponse = {
    uid?: string;
    addOns?: {
        name?: string;
        quantity?: number;
    }[];
};

export type ValidateResponse = {
    uid: string;
    addOns: {
        name: string;
        quantity: number;
    }[];
};

export const validateQuery = {
    query: () => ({
        url: 'mp/1/validate',
        method: 'post',
    }),
    transformResponse: (response: ValidateApiResponse) => ({
        uid: response.uid ?? '',
        addOns:
            response.addOns?.map((addOn) => ({
                name: addOn.name ?? '',
                quantity: addOn.quantity ?? -1,
            })) ?? [],
    }),
};
